<template>
  <div :class="inlinerows == 'true' ? inlinerowclasses + ' row' : inlinerowclasses">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? inlineLabelClass + ' col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? inlineInputClass : label ? '' : 'col-md-12'">
      <b-form-textarea v-model="text" :placeholder="placeholder" :class="classes" :type="type" :required="mandatory ? true : false" @input="onInput"></b-form-textarea>
        <small class="input-error" v-if="error">{{ error }}</small>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/form-group.scss";
import "../../assets/scss/textarea.scss";

export default {
  name: "my-text-area",
  data() {
    return {
      text: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.text = newValue; // Update text when the value prop changes
    },
  },
  created() {},
  methods: {
    onInput() {
      this.$emit("input", this.text);
    },
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    inlinerows: {
      default: false,
    },
    inlinerowclasses: {
      default: "mb-3",
    },
    inlineLabelClass: {
      default: "col-sm-2",
    },
    inlineInputClass: {
      default: "col-sm-10",
    },
    error: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      required: false,
    },
    mandatory: {
      // type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
  },
};
</script>
